// extracted by mini-css-extract-plugin
module.exports = {"CurrencyPicker":"CurrencyPicker_CurrencyPicker__kg0ai","CurrencyPickerIcon":"CurrencyPicker_CurrencyPickerIcon__jIu1G"};